var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.langs),function(l){return [_c('button',{key:l.code,class:['btn', _vm.btnClass, _vm.selected == l.code ?  'btn-primary' :'btn-outline-primary' ],attrs:{"type":"button"},on:{"click":function($event){_vm.selected = l.code}}},[_vm._v(" "+_vm._s(l.label)+" "),_vm._t("badge",null,{"badge":l})],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }